export const ADD_USER_Details = "add/user/details";
export const GET_USER_DETAILS = "get/user/details";
export const EDIT_USER_DETAILS = "edit/user/details";
export const DELETE_USER_DETAILS = "delete/user/details";
export const DELETE_ALL_USERS_DETAILS = "delete/all_user/details";
